/* pantallas-alumno (B): LA BARRA FIJA DE ACCIONES DEL CELULAR (piezas nuevas de la parte 1).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Pegada sobre la barra de abajo, fondo #0E0E0E al 96 %, linea arriba #1C1C1C, relleno 12 16. El
   resumen va centrado en 13 px #9A9A9A y debajo el boton principal de 52 a lo ancho (lo pone quien la
   usa: `<Boton alto="barra" aLoAncho>`). Solo existe abajo de 768 (sin menu lateral); desde ahi la
   pantalla pinta su boton en su lugar de computadora.

   DONDE SE APOYA: exactamente sobre la huella de la barra de abajo, con la medida UNICA de la casa
   (`ACTION_BAR_BOTTOM_CLASS` de `lib/bottomNavMetrics.js`: 70 en la app, 56 en la web, mas la zona
   segura). No se escribe ningun alto a mano. `anclaje="mueble"` la cuelga de su caja en vez de la
   pantalla (el Centro dentro del carril de la app; mismo trato que `SessionActionBar`).

   `enLinea` (las sesiones): desde 768 el MISMO nodo se vuelve estatico y sin estilo de barra, con
   `claseEnLinea` (asi los botones no se duplican ni repiten su testid; mismo trato que `inlineOnDesktop`
   de `SessionActionBar`). Sin `enLinea`, desde 768 la barra no existe.

   El contenido que se desplaza debajo reserva su espacio con `HOLGURA_DE_LA_BARRA_FIJA`. */
import React from 'react';
import { ACTION_BAR_BOTTOM_CLASS } from '../../lib/bottomNavMetrics';

// La barra mide 12 + 18 (resumen) + 8 + 52 + 12 + 1 de linea = 103; se reservan 120.
export const HOLGURA_DE_LA_BARRA_FIJA = 'pb-[120px] md:pb-0';

export default function BarraFijaDeAcciones({ resumen, children, anclaje = 'viewport', enLinea = false, claseEnLinea = '', testid, className = '' }) {
  const posicion = anclaje === 'mueble' ? 'absolute left-0 right-0' : 'fixed left-0 right-0';
  const desdeTablet = enLinea
    ? `md:static md:z-auto md:border-t-0 md:bg-transparent md:backdrop-blur-none md:p-0 ${claseEnLinea}`.trim()
    : 'md:hidden';
  return (
    <div
      data-testid={testid}
      className={`${posicion} z-40 ${ACTION_BAR_BOTTOM_CLASS} bg-[#0E0E0E]/[0.96] backdrop-blur-xl border-t border-[#1C1C1C] px-4 py-3 flex flex-col gap-2 ${desdeTablet} ${className}`.trim()}
    >
      {resumen ? <p data-parte="resumen" className="md:hidden text-center text-[13px] leading-[18px] text-[#9A9A9A] truncate">{resumen}</p> : null}
      {children}
    </div>
  );
}
